import React from "react";
import styled from "styled-components";
import { Button, Container } from "../globalStyle";
import { socialMediaLink, ProjectLinks } from "../pages/HomePage/Data";

const InfoSec = styled.div`
  color: #fff;
  padding: 160px 0;
  background: ${({ lightBg }) => (lightBg ? "#fff" : "#101522")};
`;

const InfoRow = styled.div`
  display: flex;
  margin: 0 -15px -15px -15px;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
`;

const InfoColumn = styled.div`
  margin-bottom: 15px;
  padding-right: 15px;
  padding-left: 15px;
  flex: 1;
  max-width: 50%;
  flex-basis: 50%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
`;

const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-bottom: 65px;
  }
`;

const TopLine = styled.div`
  color: ${({ lightTopLine }) => (lightTopLine ? "#a9b3c1" : "#4B59F7")};
  font-size: 18px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 1.2px;
  margin-bottom: 16px;
`;
const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 40px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? "#f7f8fa" : "#1c2237")};
`;

const SubTitle = styled.p`
  max-width: 440px;
  margin-top:80px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 1.4px;
  color: ${({ lightTextDesc }) => (lightTextDesc ? "#a9b3c1" : "#1c2237")};
`;

const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: ${({ start }) => (start ? "flex-start" : "flex-end")};
`;

const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 500px;
`;

const ButtonWrapper = styled.a`
  display: inline;
`;

const InfoSection = ({
  lightBg,
  imgStart,
  lightTopLine,
  lightText,
  lightTextDesc,
  topLine,
  headline,
  description,
  primary,
  buttonLabel,
  start,
  img,
  alt,
  skills,
  linetwo,
  linethree,
  descriptionLinetwo,
  descriptionLineThree,
  descriptionLineThreeCont,
  project,
  projectButtonLabelOne,
  projectButtonLabelTwo,
  projectButtonLabelThree,
  labelOne,
  labelTwo,
  labelThree,
  gitlink,
  deploylink,
  id,
}) => {
  return (
    <>
      <InfoSec id={id} lightBg={lightBg}>
        <Container>
          <InfoRow imgStart={imgStart}>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={lightText}>{headline}</Heading>
                <TopLine lightTopLine={lightTopLine}>{topLine}</TopLine>
                <SubTitle lightTextDesc={lightTextDesc}>{description}</SubTitle>
                {linetwo ? (
                  <SubTitle lightTextDesc={lightTextDesc}>
                    {descriptionLinetwo}
                  </SubTitle>
                ) : null}
                {linethree ? (
                  <SubTitle lightTextDesc={lightTextDesc}>
                    {descriptionLineThree}&nbsp;
                    <a href={socialMediaLink.resume}>
                      <Button primary>Resume</Button>
                    </a>
                    &nbsp;
                    {descriptionLineThreeCont}
                  </SubTitle>
                ) : null}
                {skills || project ? null : (
                  <a href={socialMediaLink.gmail}>
                    <Button big fontBig primary={primary}>
                      {buttonLabel}
                    </Button>
                  </a>
                )}

                {project ? (
                  <ButtonWrapper>
                    {labelOne ? (
                      <a href={gitlink}>
                        <Button primary={primary}>
                          {projectButtonLabelOne}
                        </Button>
                      </a>
                    ) : null}
                    {labelTwo ? (
                      <a href={deploylink}>
                        <Button primary={primary}>
                          {projectButtonLabelTwo}
                        </Button>
                      </a>
                    ) : null}
                    {labelThree ? (
                      <a href={ProjectLinks.realtimepublication}>
                        <Button primary={primary}>
                          {projectButtonLabelThree}
                        </Button>
                      </a>
                    ) : null}
                  </ButtonWrapper>
                ) : null}
              </TextWrapper>
            </InfoColumn>
            <InfoColumn>
              <ImgWrapper start={start}>
                <Img src={img} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
};

export default InfoSection;
